import React from "react";
import AutoResizeTextarea from "./AutoResizeTextarea";

export default function KokonaisKuntoarvio({ data = {}, onChange, systemType = "rakennetekniikka" }) {
  const { teksti = "", luokka = "-" } = data;

  const getColorStyle = (cls) => {
    switch (cls) {
      case "KL1": return { color: "#dc3545" };
      case "KL2": return { color: "#dc3545" };
      case "KL3": return { color: "#ffc107" };
      case "KL4":
      case "KL5": return { color: "#04aa00" };
      default: return { color: "#6c757d" };
    }
  };

  const klTextMap = {
    KL1: "heikko",
    KL2: "välttävä",
    KL3: "tyydyttävä",
    KL4: "hyvä",
    KL5: "erinomainen",
  };

 const handleLuokkaChange = (e) => {
  const newValue = e.target.value;

  if (newValue === "-") {
    onChange({ ...data, luokka: newValue, teksti: "" });
    return;
  }

  const condition = klTextMap[newValue] || "tyydyttävä";

  let newText = "";

  switch (systemType.toLowerCase()) {
    case "sähkö":
      newText = `Kohteen sähköjärjestelmien toimenpide-ehdotukset kustannusarvioineen on kokonaisuudessaan esitetty PTS-taulukossa. Kokonaisuutena sähköjärjestelmien tekninen kunto on ${condition}. `;
      break;
    case "lvi":
      newText = `Kohteen LVI-järjestelmien toimenpide-ehdotukset kustannusarvioineen on kokonaisuudessaan esitetty PTS-taulukossa. Kokonaisuutena LVI-järjestelmien tekninen kunto on ${condition}. `;
      break;
    case "rakennetekniikka":
      newText = `Kohteen rakennetekniset toimenpide-ehdotukset kustannusarvioineen on kokonaisuudessaan esitetty PTS-taulukossa. Kokonaisuutena rakennetekninen kunto on ${condition}. `;
      break;
   default:
    newText =
      `Kohteen toimenpide-ehdotukset kustannusarvioineen ` +
      `on kokonaisuudessaan esitetty PTS-taulukossa. ` +
      `Kokonaisuutena kunto on ${condition}. `;
    break;
}

  onChange({ ...data, luokka: newValue, teksti: newText });
};


  return (
    <div className="bg-white rounded shadow-sm p-3">
      <div className="d-flex align-items-center mb-3">
        <label className="me-2 fw-bold">Kuntoluokka:</label>
        <select
          className="form-select w-auto fw-bold"
          value={luokka}
          onChange={handleLuokkaChange}
          style={getColorStyle(luokka)}
        >
          <option value="-" style={{ color: "#6c757d" }}>–</option>
          <option value="KL1" style={{ color: "#ba3b46 " }}>KL1</option>
          <option value="KL2" style={{ color: "#ba3b46 " }}>KL2</option>
          <option value="KL3" style={{ color: "#d0c407" }}>KL3</option>
          <option value="KL4" style={{ color: "#04aa00" }}>KL4</option>
          <option value="KL5" style={{ color: "#04aa00" }}>KL5</option>
        </select>
      </div>

      <AutoResizeTextarea
        data={{ value: teksti }}
        onChange={(newData) => onChange({ ...data, teksti: newData.value })}
        placeholder="Valitse kuntoluokka..."
        className="form-control"
      />
    </div>
  );
}
